import { AlertController } from 'ionic-angular';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

@Injectable()
export class AcessoServiceProvider {

    private url: string = "http://www.vendamaisnaweb.com.br/appvendamais/index.php";

    constructor(private http: Http, private alertCtrl: AlertController) {

    }

    fetchData(accessKey: string): Promise<any> {

        let alert = this.alertCtrl.create({
            title: 'Falha',
            subTitle: 'Falha na chave de acesso.',
            buttons: ['Fechar']
        });

        return new Promise(resolve => {
            this.http.get(this.url + "?accessKey=" + accessKey).map(res => res.json())
                .subscribe(
                data => {
                    if (data[0].code == "200") {
                        resolve(data[0].rest);
                    } else {
                        alert.setTitle('Falha return!');
                        alert.setSubTitle(data[0].message);
                        alert.present();
                    }
                }, 
                err => {
                    alert.setTitle('Falha get!');
                    alert.setSubTitle(err);
                    alert.present();
                })
        });
    }
}



// WEBPACK FOOTER //
// ./src/providers/acesso-service.ts